import J_NA1 from '../J_NA';
import J_NA from './NA';
import J_Other from './Other';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const NA_SITES: string[] = ['us', 'ca', 'za'];

    return <>{NA_SITES.includes(locale) ? locale === 'za' ? <J_NA /> : <J_NA1 /> : <J_Other />}</>;
}
